(function () {
  'use strict';
  if (window.__ksSizeChartLoaded) return;
  window.__ksSizeChartLoaded = true;
 
  var I = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 15.5L15.5 3 21 8.5 8.5 21z"/><path d="M7 11.5l2 2M10 8.5l2 2M13 5.5l2 2"/></svg>',
    bag:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/><path d="M12 11.5v5M9.5 14h5"/></svg>',
    tick:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    pick:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    spin:  '<svg class="kssc-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 3a9 9 0 1 0 9 9"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.4v.2"/></svg>',
    info:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5.5M12 7.6v.2"/></svg>',
    user:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="3.6"/><path d="M4.5 20c.9-3.8 4-5.8 7.5-5.8s6.6 2 7.5 5.8"/></svg>',
    plus:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>'
  };
 
  var DEFAULT_MEASURE =
    '<p>Stand on a sheet of paper, mark the back of the heel and the tip of the longest toe, then measure between the two marks in centimeters or inches. Measure both feet and use the longer one. Do not order from your usual US, EU or UK size alone, because sizing runs differently from brand to brand.</p>' +
    '<p>Add the allowance below to your measured foot length, then find the corresponding internal shoe length in the chart above:</p>' +
    '<ul><li><strong>Snug fit (more control):</strong> choose a shoe with an internal length approximately 0.5 cm (0.2 inches) longer than your foot. This provides a little extra room for your toes while keeping the fit secure.</li>' +
    '<li><strong>Comfort fit (more room):</strong> choose a shoe with an internal length 0.5 to 1 cm (0.2 to 0.39 inches) longer than your foot. This provides additional toe room. For a growing child, make sure the shoe still fits securely and the heel does not slip.</li></ul>';
 
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function trim(n) { return (Math.round(n * 10) / 10).toFixed(1).replace(/\.0$/, ''); }
  /* "[size] fits a [length] foot" — the template is escaped first, the
     values put in are already safe HTML. */
  function fill(tpl, map) {
    return esc(tpl).replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }
  function plain(tpl, map) {
    return String(tpl).replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }
  function usOf(v) { return parseFloat(String(v).replace(/[^0-9.]/g, '')); }
  function later(fn, ms) { return setTimeout(fn, ms || 0); }
 
  function init(root) {
    if (!root || root.getAttribute('data-kssc-ready') === '1') return;
    var KS = window.KSFinder;
    var cfgEl = root.querySelector('[data-kssc-config]');
    if (!KS || typeof KS.build !== 'function' || !cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var me = KS.build(cfg.product);
    if (!me) return;
    root.setAttribute('data-kssc-ready', '1');
 
    var T = cfg.t || {};
    function tx(k, d) { var v = T[k]; return v == null || v === '' ? d : v; }
    var SV = KS.sizes && KS.sizes.on ? KS.sizes : null;
    var ADD = cfg.tap !== 'select';
 
    /* ---------- the theme's own size and color pickers ---------- */
    var scope = root.closest('.shopify-section') || document;
    var SIZE_KEY = 'option' + cfg.sizePos, COLOR_KEY = 'option' + cfg.colorPos;
    function firstIn(el, key) {
      return el.querySelector('input[type=radio][data-index="' + key + '"]') ||
             el.querySelector('select[data-index="' + key + '"]');
    }
    function wrapOf(a) { return a ? (a.closest('.variant-wrapper') || a.closest('fieldset') || a.parentNode) : null; }
    var sizeWrap = wrapOf(firstIn(scope, SIZE_KEY));
    var colorWrap = cfg.colorPos ? wrapOf(firstIn(scope, COLOR_KEY)) : null;
 
    function radios(wrap, key) {
      return wrap ? Array.prototype.slice.call(wrap.querySelectorAll('input[type=radio][data-index="' + key + '"]')) : [];
    }
    function current(wrap, key) {
      var r = radios(wrap, key).filter(function (x) { return x.checked; })[0];
      if (r) return r.value;
      var s = wrap ? wrap.querySelector('select[data-index="' + key + '"]') : null;
      return s ? s.value : '';
    }
    function choose(wrap, key, value) {
      var r = radios(wrap, key).filter(function (x) { return x.value === value; })[0];
      if (r) {
        if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        return true;
      }
      var s = wrap ? wrap.querySelector('select[data-index="' + key + '"]') : null;
      if (s && Array.prototype.some.call(s.options, function (o) { return o.value === value; })) {
        if (s.value !== value) { s.value = value; s.dispatchEvent(new Event('change', { bubbles: true })); }
        return true;
      }
      return false;
    }
    function sizeValue(us) {
      var s = cfg.product.s || [];
      for (var i = 0; i < s.length; i++) if (usOf(s[i]) === us) return s[i];
      return String(us);
    }
    /* The theme only follows the buttons once its own script has
       started. Until the variant in the cart form matches, keep telling it. */
    var syncT = null;
    function syncTheme(tries) {
      clearTimeout(syncT);
      if (!sizeWrap) return;
      var us = usOf(current(sizeWrap, SIZE_KEY));
      var c = colorWrap ? current(colorWrap, COLOR_KEY) : '';
      var want = variantFor(us, c);
      var master = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      if (!want || !master || String(master.value) === String(want.id) || tries > 32) return;
      syncT = later(function () {
        var r = radios(sizeWrap, SIZE_KEY).filter(function (x) { return x.checked; })[0];
        if (r) r.dispatchEvent(new Event('change', { bubbles: true }));
        syncTheme(tries + 1);
      }, tries ? 250 : 60);
    }
 
    /* ---------- variants ---------- */
    var COLORS = [];
    (cfg.variants || []).forEach(function (v) { if (v.c && COLORS.indexOf(v.c) < 0) COLORS.push(v.c); });
    var HAS_COLOR = !!cfg.colorPos && COLORS.length > 0;
    var CIMG = cfg.cimg || {};
    /* each color: a small picture ("s") and a big one for the mouse-over ("l") */
    function pic(c) {
      var x = HAS_COLOR && c ? CIMG[c] : null;
      if (typeof x === 'string') return { s: x, l: x };
      return x && typeof x.s === 'string' && x.s ? { s: x.s, l: x.l || x.s } : null;
    }
    function imgOf(c) { var p = pic(c); return p ? p.s : ''; }
    function bigOf(c) { var p = pic(c); return p ? p.l : ''; }
    /* a color button, with the shoe in that color when there is a picture */
    function colorChip(c, on) {
      var src = imgOf(c);
      return '<button type="button" class="kssc-chip' + (src ? ' has-img' : '') + (on ? ' is-on' : '') + '" data-color="' + esc(c) + '"' +
        (on === null ? '' : ' aria-pressed="' + !!on + '"') +
        (src ? ' data-peek="' + esc(bigOf(c)) + '" data-peek-label="' + esc(c) + '"' : '') + '>' +
        (src ? '<img src="' + esc(src) + '" alt="" width="36" height="36" decoding="async">' : '') +
        esc(c) + '</button>';
    }
    function variantFor(us, color) {
      var hit = null;
      (cfg.variants || []).forEach(function (v) {
        if (usOf(v.s) !== us) return;
        if (HAS_COLOR && v.c !== color) return;
        if (!hit || (!hit.a && v.a)) hit = v;
      });
      return hit;
    }
    function colorsWith(us) {
      return COLORS.filter(function (c) { var v = variantFor(us, c); return v && v.a; });
    }
 
    /* ---------- state ---------- */
    var FIRST = me.rows[0][1] - KS.maxRoom, LAST = me.rows[me.rows.length - 1][1] - KS.minRoom;
    var RMIN = Math.min(13, Math.floor(FIRST) - 1), RMAX = Math.max(30, Math.ceil(LAST) + 1);
    var last = KS.recall ? (KS.recall() || {}) : {};
    var DEF = last.foot >= RMIN && last.foot <= RMAX ? +last.foot : 22;
    var S = {
      foot: NaN, fit: 'comfort', socks: false, pid: '',
      unit: last.unit === 'in' ? 'in' : 'cm',
      color: '', busy: null, done: null, note: null, opener: null, open: false
    };
 
    function sizeTxt(r) { return 'US ' + r.us + (!isNaN(r.eu) ? ' · EU ' + r.eu : ''); }
    function itemTxt(us) { return (HAS_COLOR && S.color ? S.color + ' / ' : '') + 'US ' + us; }
    function lenTxt(cm) { return S.unit === 'in' ? (cm / 2.54).toFixed(2) + ' in' : trim(cm) + ' cm'; }
    function rec() {
      if (!(S.foot >= 10 && S.foot <= 40)) return null;
      var r = KS.sizeFor(me, S.foot, { fit: S.fit, socks: S.socks });
      if (!r) return { none: true };
      return { r: r, pick: r.bestAny };
    }
 
    /* ---------- the window, built on first open ---------- */
    var dlg = null, body, statusEl, tbody, input, rimg = null;
    var uid = 'kssc-' + String(cfg.id || 'x').replace(/[^\w-]/g, '');
    var HAS_CONV = !!cfg.foot && cfg.conv !== false && typeof KS.brandList === 'function' && KS.brandList().length > 0;
    var FIND_FIRST = cfg.layout === 'finder';
    S.tab = 'foot';
 
    function rangeTxt() {
      var a = me.rows[0], b = me.rows[me.rows.length - 1];
      return {
        us: '<b>US ' + a[0] + ' to ' + b[0] + '</b>',
        eu: '<b>EU ' + a[2] + ' to ' + b[2] + '</b>',
        cm: '<b>' + a[1].toFixed(1) + ' to ' + b[1].toFixed(1) + ' cm (' + (a[1] / 2.54).toFixed(2) + ' to ' + (b[1] / 2.54).toFixed(2) + ' inches)</b>',
        model: '<b>' + esc(me.title) + '</b>'
      };
    }
 
    /* color and saved sizes: both change what the chart shows, so they
       sit right above it */
    function topHtml() {
      var colors = cfg.colors && HAS_COLOR && COLORS.length > 1;
      var saved = cfg.foot && !!SV;
      if (!colors && !saved) return '';
      return '<div class="kssc-top">' +
        (colors ? '<div class="kssc-row"><span class="kssc-lab">' + esc(tx('color', 'Color')) + '</span><div class="kssc-chips" data-colors></div></div>' : '') +
        (saved ? '<div class="kssc-row" data-savedrow hidden><span class="kssc-lab">' + esc((SV.t && SV.t.saved) || 'Saved sizes') + '</span><div class="kssc-chips" data-saved></div></div>' : '') +
      '</div>';
    }
 
    function chartHtml() {
      var rows = me.rows.map(function (r) {
        return '<tr data-us="' + r[0] + '">' +
          '<td>' + r[1].toFixed(1) + '</td>' +
          '<td>' + (r[1] / 2.54).toFixed(2) + '</td>' +
          '<td>' + r[0] + '<span class="kssc-badge">' + esc(tx('best', 'Best fit')) + '</span></td>' +
          '<td>' + r[2] + '</td>' +
          '<td class="kssc-act"></td></tr>';
      }).join('');
      return '<div class="kssc-status" data-status aria-live="polite"></div>' +
        '<div class="kssc-wrap"><table class="kssc-t">' +
          '<caption class="kssc-vh">' + esc(tx('title', 'Size chart')) + ': ' + esc(me.title) + '</caption>' +
          '<thead><tr>' +
            '<th scope="colgroup" colspan="2">' + esc(tx('inner', 'Inner length')) + '</th>' +
            '<th scope="col" rowspan="2" class="kssc-big">US</th>' +
            '<th scope="col" rowspan="2" class="kssc-big">EU</th>' +
            '<th scope="col" rowspan="2" class="kssc-act"><span class="kssc-vh">' + esc(ADD ? 'Add to cart' : 'Select') + '</span></th>' +
          '</tr><tr><th scope="col">cm</th><th scope="col">inches</th></tr></thead>' +
          '<tbody data-rows>' + rows + '</tbody>' +
        '</table></div>';
    }
 
    /* "Find your size": the foot length or a sneaker size they already
       own, the fit, and the answer with its own add button, so nobody
       has to scroll back up to the chart to buy */
    function findHtml() {
      if (!cfg.foot) return '';
      var fh = esc(tx('find', 'Find your size'));
      return '<section class="kssc-find' + (FIND_FIRST ? ' is-first' : '') + '" id="' + uid + '-f" aria-labelledby="' + uid + '-fh">' +
        '<h3 class="kssc-fh" id="' + uid + '-fh">' + fh + '</h3>' +
        (HAS_CONV ?
          '<div class="kssc-tabs" role="group" aria-label="' + fh + '">' +
            '<button type="button" data-tab="foot" aria-pressed="true">' + esc(tx('tab_foot', 'Foot length')) + '</button>' +
            '<button type="button" data-tab="brand" aria-pressed="false">' + esc(tx('tab_brand', 'Sneaker size')) + '</button>' +
          '</div>' : '') +
        '<div data-kpane="foot">' +
          '<div class="kssc-yh"><span class="kssc-lab">' + esc(tx('foot', 'Your foot length')) + '</span>' +
            '<div class="kssc-seg" role="group" aria-label="Unit"><button type="button" data-unit="cm">cm</button><button type="button" data-unit="in">in</button></div></div>' +
          '<div class="kssc-dial">' +
            '<button type="button" class="kssc-pm" data-inc="-1" aria-label="Shorter">' + I.minus + '</button>' +
            '<label class="kssc-num"><input type="number" inputmode="decimal" step="0.1" min="5" max="40" aria-label="' + esc(tx('foot', 'Your foot length')) + '" data-foot><span data-unitlab>cm</span></label>' +
            '<button type="button" class="kssc-pm" data-inc="1" aria-label="Longer">' + I.plus + '</button>' +
          '</div>' +
          (cfg.measure ? '<div class="kssc-hw"><a class="kssc-how" href="#' + uid + '-m" data-how>' + esc(tx('how', 'How to measure?')) + '</a></div>' : '') +
        '</div>' +
        (HAS_CONV ?
          '<div data-kpane="brand" hidden>' +
            '<div class="kssc-yh"><span class="kssc-lab">' + esc(tx('tab_brand', 'Sneaker size')) + '</span>' +
              '<div class="kssc-seg" role="group" aria-label="Size system"><button type="button" data-csys="us">US</button><button type="button" data-csys="eu">EU</button></div></div>' +
            '<div class="kssc-conv"><select data-cb aria-label="Brand"></select><select data-cg aria-label="Who for"></select><select data-cs aria-label="Size"></select></div>' +
            '<p class="kssc-cnote" data-cn></p>' +
          '</div>' : '') +
        '<div class="kssc-fith"><span class="kssc-lab">' + esc(tx('fit_h', 'How should it fit?')) + '</span></div>' +
        '<div class="kssc-fits" role="group" aria-label="Fit">' +
          ['snug', 'comfort', 'grow'].map(function (k) {
            return '<button type="button" class="kssc-fit" data-fit="' + k + '" aria-pressed="false"><b>' + esc(KS.fits[k].label) + '</b><small>+' + KS.fits[k].target + ' cm</small></button>';
          }).join('') +
        '</div>' +
        '<div class="kssc-res" data-res aria-live="polite"></div>' +
      '</section>';
    }
 
    /* the logo above the title: the one from the settings, or else the
       one in the site header */
    function logoHtml() {
      if (cfg.logoShow === 'off') return '';
      var src = cfg.logo || '';
      if (!src) {
        var h = document.querySelector('.site-header__logo-link img, .site-header__logo img, .header__heading-logo');
        if (h) src = h.currentSrc || h.src || '';
      }
      if (!src) return '';
      return '<img class="kssc-logo' + (cfg.logoShow === 'desktop' ? ' is-desk' : '') + '" src="' + esc(src) + '" alt="' + esc(cfg.logoAlt || '') + '">';
    }
 
    function build() {
      dlg = document.createElement('div');
      dlg.className = 'kssc';
      dlg.hidden = true;
      dlg.innerHTML =
        '<div class="kssc-back" data-close></div>' +
        '<div class="kssc-box" role="dialog" aria-modal="true" aria-labelledby="' + uid + '-t">' +
          '<div class="kssc-head">' +
            '<span class="kssc-grab" aria-hidden="true"></span>' +
            '<div>' + logoHtml() + '<h2 class="kssc-title" id="' + uid + '-t">' + esc(tx('title', 'Size chart')) + '</h2>' +
            '<p class="kssc-model">' + esc(me.title) + '</p></div>' +
            '<button type="button" class="kssc-x" data-close aria-label="Close">' + I.close + '</button>' +
          '</div>' +
          '<div class="kssc-body" data-body>' +
            topHtml() +
            (FIND_FIRST ? findHtml() + chartHtml() : chartHtml() + findHtml()) +
            (cfg.summary ? '<p class="kssc-sum">' + fill(tx('summary', 'This chart applies to the [model] and covers [us], [eu], with internal shoe lengths of [cm]. These measurements refer to the space inside the shoe, not your foot length.'), rangeTxt()) + '</p>' : '') +
            (cfg.measure ?
              '<div class="kssc-measure" id="' + uid + '-m">' +
                '<h3 class="kssc-mh">' + esc(tx('measure_h', 'How to measure your foot')) + '</h3>' +
                (cfg.img ? '<img src="' + esc(cfg.img) + '" alt="' + esc(cfg.imgAlt || '') + '" loading="lazy" width="720" height="440">' : '') +
                '<div class="kssc-rte">' + (cfg.measureHtml || DEFAULT_MEASURE) + '</div>' +
              '</div>' : '') +
            (cfg.guide ? '<p class="kssc-guide"><a class="kssc-a" href="' + esc(cfg.guide) + '">' + esc(tx('guide', 'Still unsure? See the complete size guide')) + '</a></p>' : '') +
          '</div>' +
        '</div>';
      document.body.appendChild(dlg);
      body = dlg.querySelector('[data-body]');
      statusEl = dlg.querySelector('[data-status]');
      tbody = dlg.querySelector('[data-rows]');
      input = dlg.querySelector('[data-foot]');
      bind();
      Array.prototype.forEach.call(dlg.querySelectorAll('.kssc-top .kssc-chips'), function (el) {
        el.addEventListener('scroll', function () { rowEdges(el); }, { passive: true });
      });
      window.addEventListener('resize', function () {
        if (S.open) Array.prototype.forEach.call(dlg.querySelectorAll('.kssc-top .kssc-chips'), rowEdges);
      });
    }
 
    /* ---------- painting ---------- */
    function $(s) { return dlg.querySelector(s); }
    function $$(s) { return Array.prototype.slice.call(dlg.querySelectorAll(s)); }
    function pressed(sel, attr, value) {
      $$(sel).forEach(function (b) {
        var on = b.getAttribute(attr) === value;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
      });
    }
 
    function paintFoot() {
      if (!input) return;
      pressed('[data-unit]', 'data-unit', S.unit);
      $('[data-unitlab]').textContent = S.unit;
      input.step = S.unit === 'in' ? '0.05' : '0.1';
      input.placeholder = S.unit === 'in' ? (DEF / 2.54).toFixed(2) : DEF.toFixed(1);
      if (document.activeElement !== input) {
        input.value = isNaN(S.foot) ? '' : S.unit === 'in' ? (S.foot / 2.54).toFixed(2) : S.foot.toFixed(1);
      }
      pressed('[data-fit]', 'data-fit', S.fit);
      pressed('[data-tab]', 'data-tab', S.tab);
      $$('[data-kpane]').forEach(function (p) { p.hidden = p.getAttribute('data-kpane') !== S.tab; });
    }
 
    function paintSaved() {
      var box = $('[data-saved]');
      if (!box) return;
      var list = SV ? SV.list() : [];
      $('[data-savedrow]').hidden = !list.length;
      var html = list.map(function (p) {
        return '<button type="button" class="kssc-chip' + (S.pid === p.id ? ' is-on' : '') + '" data-pid="' + esc(p.id) + '" aria-pressed="' + (S.pid === p.id) + '">' +
          I.user + '<b>' + esc(p.name) + '</b><span>' + esc(lenTxt(p.foot)) + '</span></button>';
      }).join('');
      if (box.innerHTML !== html) box.innerHTML = html;
      rowShow(box, true);
    }
 
    /* only rebuilt when something changed, so the pictures do not blink */
    function put(el, html) {
      if (el._ksscK === html) return;
      el._ksscK = html;
      el.innerHTML = html;
    }
 
    /* Phones: the colors are one row that scrolls sideways. The side
       with more to see fades out, and the one chosen is scrolled into
       view. On computers the row wraps and none of this does anything. */
    function rowEdges(el) {
      var max = el.scrollWidth - el.clientWidth;
      el.classList.toggle('kssc-more-l', max > 2 && el.scrollLeft > 2);
      el.classList.toggle('kssc-more-r', max > 2 && el.scrollLeft < max - 2);
    }
    function rowShow(el, smooth) {
      if (!el || !S.open || dlg.hidden) return;
      var on = el.querySelector('.is-on');
      if (on && el.scrollWidth > el.clientWidth + 2) {
        var pad = parseFloat(getComputedStyle(el).paddingLeft) || 0;
        var r = on.getBoundingClientRect(), b = el.getBoundingClientRect(), x = el.scrollLeft;
        if (r.left < b.left + pad) x += r.left - b.left - pad;
        else if (r.right > b.right - pad) x += r.right - b.right + pad;
        if (Math.abs(x - el.scrollLeft) > 1) {
          try { el.scrollTo({ left: x, behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { el.scrollLeft = x; }
        }
      }
      rowEdges(el);
    }
 
    function paintColors() {
      var box = $('[data-colors]');
      if (!box) return;
      put(box, COLORS.map(function (c) { return colorChip(c, c === S.color); }).join(''));
      rowShow(box, true);
    }
 
    function btnIcon(us) { return S.busy === us ? I.spin : S.done === us ? I.tick : ADD ? I.bag : I.pick; }
    function actLabel(us) {
      return plain(ADD ? tx('add_aria', 'Add [item] to the cart') : tx('select_aria', 'Select [item]'), { item: itemTxt(us) });
    }
 
    function paintRows(bestUs) {
      Array.prototype.forEach.call(tbody.rows, function (tr) {
        var us = parseFloat(tr.getAttribute('data-us'));
        var v = variantFor(us, S.color);
        var ok = !!(v && v.a);
        tr.className = [ok ? 'is-ok' : 'is-off', us === bestUs ? 'is-best' : '', S.done === us ? 'is-done' : ''].join(' ').trim();
        var label = actLabel(us);
        var key = (ok ? 'b' : v ? 'o' : 'n') + (S.busy === us ? 's' : S.done === us ? 'd' : '') + '|' + label;
        var cell = tr.cells[tr.cells.length - 1];
        if (cell.getAttribute('data-k') === key) return;
        cell.setAttribute('data-k', key);
        cell.innerHTML = ok
          ? '<button type="button" class="kssc-add" data-add="' + us + '" aria-label="' + esc(label) + '" title="' + esc(label) + '">' + btnIcon(us) + '</button>'
          : '<span class="kssc-out">' + esc(v ? tx('soldout', 'Sold out') : tx('na', 'Not made')) + '</span>';
      });
    }
 
    /* the size that fits is sold out in this color: say where it is not */
    function outHtml(p) {
      var map = { size: '<b>' + esc(sizeTxt(p)) + '</b>', color: esc(S.color) };
      var others = colorsWith(p.us);
      if (HAS_COLOR && others.length) {
        return '<p>' + fill(tx('out', '[size] is sold out in [color]. In stock in:'), map) + '</p>' +
          '<div class="kssc-chips">' + others.map(function (c) { return colorChip(c, null); }).join('') + '</div>';
      }
      return '<p>' + fill(tx('gone', '[size] is sold out in every color.'), map) + '</p>';
    }
 
    /* the line right above the chart */
    function paintStatus(x) {
      var icon = I.info, cls = 'is-info', html = '';
      var tap = esc(ADD ? tx('tap_add', 'Tap a size to add it to the cart.') : tx('tap_select', 'Tap a size to select it.'));
      var more = !FIND_FIRST && cfg.foot ? '<button type="button" class="kssc-a" data-find>' + esc(tx('more', 'Not sure which size? Find it below')) + '</button>' : '';
      if (S.note) {
        icon = S.note.ok ? I.check : I.alert;
        cls = S.note.ok ? 'is-ok' : 'is-warn';
        html = '<p>' + S.note.html + '</p>';
      } else if (!x) {
        html = '<p>' + tap + '</p>' + (more ? '<p class="kssc-m">' + more + '</p>' : '');
      } else if (x.none) {
        icon = I.alert; cls = 'is-warn';
        html = '<p>' + fill(tx('none', 'This model is not made for a [length] foot.'), { length: esc(lenTxt(S.foot)) }) + '</p>' +
          '<p class="kssc-m">' + tap + '</p>';
      } else {
        var p = x.pick, v = variantFor(p.us, S.color);
        if (v && v.a) {
          icon = I.check; cls = 'is-ok';
          html = '<p>' + fill(tx('fit', '[size] fits a [length] foot best, with [room] of room.'),
            { size: '<b>' + esc(sizeTxt(p)) + '</b>', length: esc(lenTxt(S.foot)), room: esc(lenTxt(p.room)) }) + '</p>' +
            '<p class="kssc-m">' + tap + '</p>';
        } else {
          icon = I.alert; cls = 'is-warn';
          html = outHtml(p);
        }
      }
      statusEl.className = 'kssc-status ' + cls;
      put(statusEl, icon + '<div>' + html + '</div>');
    }
 
    /* the answer under "Find your size", with its own button */
    function paintResult(x) {
      var box = $('[data-res]');
      if (!box) return;
      var cls = 'kssc-res', html;
      if (!x) {
        cls += ' is-info';
        html = '<div class="kssc-rmsg">' + I.info + '<div><p>' + esc(tx('hint', 'Enter your foot length or sneaker size to see which size fits.')) + '</p></div></div>';
      } else if (x.none) {
        cls += ' is-warn';
        html = '<div class="kssc-rmsg">' + I.alert + '<div><p>' + fill(tx('none', 'This model is not made for a [length] foot.'), { length: esc(lenTxt(S.foot)) }) + '</p></div></div>';
      } else {
        var p = x.pick, v = variantFor(p.us, S.color);
        if (v && v.a) {
          var src = imgOf(S.color);
          cls += ' is-ok' + (src ? ' has-img' : '');
          html = (src ? '<i data-rimg="' + esc(src) + '"></i>' : '') +
            '<div class="kssc-rt"><small>' + esc(tx('best', 'Best fit')) + '</small><b>' + esc(sizeTxt(p)) + '</b>' +
              '<span>' + fill(tx('room', '[room] of room at the toe'), { room: esc(lenTxt(p.room)) }) + '</span></div>' +
            '<div class="kssc-ra"><button type="button" class="kssc-radd" data-radd="' + p.us + '">' + btnIcon(p.us) + '<span>' + esc(actLabel(p.us)) + '</span></button>' +
              '<button type="button" class="kssc-show" data-show>' + esc(tx('show', 'Show it in the chart')) + '</button></div>';
        } else {
          cls += ' is-warn';
          html = '<div class="kssc-rmsg">' + I.alert + '<div>' + outHtml(p) + '</div></div>';
        }
      }
      box.className = cls;
      put(box, html);
      /* the picture is one element that moves into place, so it does not
         load again while the foot length is typed or held with − / + */
      var slot = box.querySelector('i[data-rimg]');
      if (slot) {
        if (!rimg) {
          rimg = document.createElement('img');
          rimg.className = 'kssc-rimg';
          rimg.width = 60; rimg.height = 60;
          rimg.decoding = 'async';
        }
        if (rimg.getAttribute('src') !== slot.getAttribute('data-rimg')) rimg.setAttribute('src', slot.getAttribute('data-rimg'));
        rimg.alt = S.color;
        rimg.setAttribute('data-peek', bigOf(S.color));
        rimg.setAttribute('data-peek-label', S.color);
        slot.parentNode.replaceChild(rimg, slot);
      }
    }
 
    function paint() {
      if (!dlg) return;
      var x = rec();
      paintFoot();
      paintSaved();
      paintColors();
      paintRows(x && !x.none ? x.pick.us : null);
      paintStatus(x);
      paintResult(x);
    }
 
    function scrollToEl(el, center) {
      if (!el) return;
      var rb = el.getBoundingClientRect(), bb = body.getBoundingClientRect();
      var top = body.scrollTop + rb.top - bb.top - (center ? (bb.height - rb.height) / 2 : 12);
      try { body.scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); } catch (e) { body.scrollTop = Math.max(0, top); }
    }
 
    /* ---------- open and close ---------- */
    function prefill() {
      var list = SV ? SV.list() : [];
      var kept = SV && cfg.keep ? SV.pick() : '';
      var p = (kept && SV.get(kept)) || (list.length === 1 ? list[0] : null);
      if (p) { S.pid = p.id; S.foot = p.foot; S.fit = p.fit; S.socks = !!p.socks; return; }
      var l = KS.recall ? (KS.recall() || {}) : {};
      if (l.foot >= 10 && l.foot <= 40) {
        S.foot = Math.round(+l.foot * 10) / 10;
        S.fit = KS.fits[l.fit] ? l.fit : 'comfort';
        S.socks = !!l.socks;
      }
    }
    function open(opener) {
      if (!dlg) build();
      if (S.open) return;
      S.open = true;
      S.opener = opener || document.activeElement;
      var pageColor = colorWrap ? current(colorWrap, COLOR_KEY) : '';
      S.color = HAS_COLOR ? (COLORS.indexOf(pageColor) > -1 ? pageColor : COLORS[0]) : '';
      S.note = null; S.done = null; S.busy = null;
      if (isNaN(S.foot) || (S.pid && SV && !SV.get(S.pid))) { S.pid = ''; S.foot = NaN; prefill(); }
      paint();
      resetSheet();
      body.scrollTop = 0;
      dlg.hidden = false;
      /* now that it can be measured: the chosen color in view, no animation */
      $$('.kssc-top .kssc-chips').forEach(function (el) { rowShow(el, false); });
      document.documentElement.classList.add('kssc-lock');
      later(function () { dlg.classList.add('is-open'); }, 20);
      /* bring the highlighted size into view if it is below the fold */
      later(function () {
        var row = tbody.querySelector('tr.is-best');
        if (!row || FIND_FIRST) return;
        var rb = row.getBoundingClientRect(), bb = body.getBoundingClientRect();
        if (rb.bottom > bb.bottom - 8) body.scrollTop += rb.bottom - bb.bottom + 24;
      }, 40);
      later(function () { var x = $('.kssc-x'); if (x) x.focus(); }, 60);
      later(preloadBig, 500);
      KS.track('ks_chart_open', { model: me.title });
    }
    function close(keepFocus) {
      if (!dlg || !S.open) return;
      S.open = false;
      peekHide();
      dlg.classList.remove('is-open');
      document.documentElement.classList.remove('kssc-lock');
      later(function () { if (!S.open) { dlg.hidden = true; resetSheet(); } }, 260);
      if (!keepFocus && S.opener && S.opener.focus) { try { S.opener.focus(); } catch (e) {} }
    }
 
    /* ---------- the cart ---------- */
    function cartUrl() {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return r + 'cart/add.js';
    }
    function tellTheme(item, openCart) {
      var th = window.theme || {};
      if (openCart && th.settings && th.settings.cartType === 'page') {
        location.href = (th.routes && th.routes.cartPage) || '/cart';
        return;
      }
      if (openCart) {
        /* the same event the theme's own Add to cart button sends: the
           cart drawer rebuilds itself and slides open */
        var form = scope.querySelector('form[action*="/cart/add"]');
        var btn = form ? form.querySelector('[type="submit"], [name="add"]') : null;
        (form || document).dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: item, addToCartBtn: btn }, bubbles: true
        }));
      } else {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    }
    function addToCart(us) {
      var v = variantFor(us, S.color);
      if (!v || !v.a || S.busy !== null) return;
      S.busy = us; S.done = null; S.note = null;
      paint();
      var x = rec();
      fetch(cartUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok) throw d;
          return d;
        });
      }).then(function (item) {
        S.busy = null;
        KS.track('ks_chart_add', { model: me.title, size: us, color: S.color || '', best: !!(x && !x.none && x.pick.us === us) });
        if (cfg.after !== 'stay') {
          close(true);
          tellTheme(item, true);
          return;
        }
        S.done = us;
        S.note = { ok: true, html: fill(tx('added', '[item] is in your cart.'), { item: '<b>' + esc(itemTxt(us)) + '</b>' }) +
          ' <button type="button" class="kssc-a" data-cart>' + esc(tx('view', 'View cart')) + '</button>' };
        tellTheme(item, false);
        paint();
      }).catch(function (err) {
        S.busy = null;
        var m = err && (err.description || err.message);
        S.note = { ok: false, html: esc(typeof m === 'string' && m ? m : tx('error', 'Could not add it to the cart. Please try again.')) };
        paint();
      });
    }
    function selectOnPage(us) {
      if (HAS_COLOR && S.color && colorWrap) choose(colorWrap, COLOR_KEY, S.color);
      if (sizeWrap && choose(sizeWrap, SIZE_KEY, sizeValue(us))) syncTheme(0);
      KS.track('ks_chart_select', { model: me.title, size: us, color: S.color || '' });
      close();
    }
    function tapRow(us) {
      var v = variantFor(us, S.color);
      if (!v || !v.a) return;
      if (ADD) addToCart(us); else selectOnPage(us);
    }
 
    /* ---------- the shopper's foot ---------- */
    var tDraft = null;
    function onDraft(fromBrand) {
      S.pid = ''; S.note = null; S.done = null;
      if (!fromBrand) { var cn = dlg && dlg.querySelector('[data-cn]'); if (cn) cn.innerHTML = ''; }
      if (SV && cfg.keep) SV.pick(null);
      paint();
      clearTimeout(tDraft);
      tDraft = later(function () {
        if (S.foot >= 10 && S.foot <= 40) KS.remember({ foot: S.foot, fit: S.fit, socks: S.socks, unit: S.unit });
      }, 400);
    }
    function bump(dir) {
      var cm;
      if (S.unit === 'in') {
        var inch = isNaN(S.foot) ? Math.round(DEF / 2.54 * 20) / 20 : Math.round((S.foot / 2.54 + dir * 0.05) * 20) / 20;
        cm = inch * 2.54;
      } else {
        cm = isNaN(S.foot) ? DEF : Math.round((S.foot + dir * 0.1) * 10) / 10;
      }
      S.foot = Math.round(Math.min(RMAX, Math.max(RMIN, cm)) * 100) / 100;
      onDraft();
    }
 
    /* ---------- the bigger picture: computers, when the mouse is over a
       color or over the picture next to the answer ---------- */
    var peekEl = null, peekOn = null, preloaded = false;
    function canPeek() {
      return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    }
    function peekShow(el) {
      var src = el.getAttribute('data-peek');
      if (!src) return;
      if (!peekEl) {
        peekEl = document.createElement('div');
        peekEl.className = 'kssc-peek';
        peekEl.setAttribute('aria-hidden', 'true');
        peekEl.innerHTML = '<img alt="" width="256" height="256" decoding="async"><span></span>';
        dlg.appendChild(peekEl);
      }
      var im = peekEl.firstChild;
      if (im.getAttribute('src') !== src) im.setAttribute('src', src);
      peekEl.lastChild.textContent = el.getAttribute('data-peek-label') || '';
      peekOn = el;
      /* under the picture when it is in the top half of the screen, above
         it in the bottom half, always inside the screen */
      var r = el.getBoundingClientRect(), w = peekEl.offsetWidth, h = peekEl.offsetHeight;
      var vw = dlg.clientWidth, vh = dlg.clientHeight;
      var left = Math.max(8, Math.min(vw - w - 8, r.left + r.width / 2 - w / 2));
      var top = r.top + r.height / 2 < vh / 2 ? r.bottom + 10 : r.top - 10 - h;
      if (top + h > vh - 8) top = r.top - 10 - h;
      if (top < 8) top = Math.max(8, Math.min(vh - h - 8, r.bottom + 10));
      peekEl.style.left = Math.round(left) + 'px';
      peekEl.style.top = Math.round(top) + 'px';
      peekEl.classList.add('is-on');
    }
    function peekHide() {
      peekOn = null;
      if (peekEl) peekEl.classList.remove('is-on');
    }
    /* the big pictures load while the shopper looks at the chart, so they
       are there the moment the mouse reaches a color */
    function preloadBig() {
      if (preloaded || !canPeek()) return;
      preloaded = true;
      COLORS.forEach(function (c) {
        var b = bigOf(c);
        if (b) { var im = new Image(); im.decoding = 'async'; im.src = b; }
      });
    }
    function bindPeek() {
      dlg.addEventListener('pointerover', function (e) {
        if (e.pointerType !== 'mouse') return;
        var el = e.target && e.target.closest ? e.target.closest('[data-peek]') : null;
        if (!el || !canPeek()) { if (peekOn) peekHide(); return; }
        if (el !== peekOn) peekShow(el);
      });
      dlg.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') peekHide(); });
      body.addEventListener('scroll', function () { if (peekOn) peekHide(); }, { passive: true });
    }
 
    /* ---------- phones: pull the sheet down to close it ----------
       From the title bar at any time, or from the content when it is
       scrolled to the top. Far or fast enough closes it, anything less
       springs back. */
    var resetSheet = function () {};
    function bindSwipe() {
      var box = dlg.querySelector('.kssc-box'), back = dlg.querySelector('.kssc-back'), head = dlg.querySelector('.kssc-head');
      var mq = window.matchMedia ? window.matchMedia('(max-width: 640px)') : null;
      var g = null, stopClick = 0;
      function sheet(y, anim) {
        box.style.transition = anim ? 'transform .25s cubic-bezier(.2,.8,.2,1)' : 'none';
        box.style.transform = y ? 'translateY(' + y + 'px)' : '';
        back.style.transition = anim ? 'opacity .25s' : 'none';
        back.style.opacity = y ? String(Math.max(0.15, 1 - y / (box.offsetHeight || 600))) : '';
      }
      dlg.addEventListener('touchstart', function (e) {
        g = null;
        if (!S.open || !mq || !mq.matches || !e.touches || e.touches.length !== 1) return;
        var t = e.target;
        if (!t || !t.closest) return;
        var inHead = head.contains(t);
        if (!inHead && !body.contains(t)) return;
        if (t.closest('input, select, textarea, .kssc-pm')) return;
        var p = e.touches[0];
        g = { x: p.clientX, y: p.clientY, head: inHead, top: body.scrollTop <= 0, on: false, dy: 0, ly: p.clientY, lt: Date.now(), v: 0 };
      }, { passive: true });
      dlg.addEventListener('touchmove', function (e) {
        if (!g || !e.touches || !e.touches.length) return;
        var p = e.touches[0], dx = p.clientX - g.x, dy = p.clientY - g.y;
        if (!g.on) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          /* up, sideways, or the content is not at its top: a normal scroll */
          if (dy <= 0 || Math.abs(dx) > Math.abs(dy) || (!g.head && (!g.top || body.scrollTop > 0))) { g = null; return; }
          g.on = true;
          peekHide();
        }
        if (e.cancelable) e.preventDefault();
        var now = Date.now();
        g.v = (p.clientY - g.ly) / Math.max(1, now - g.lt);
        g.ly = p.clientY; g.lt = now;
        g.dy = Math.max(0, p.clientY - g.y);
        sheet(g.dy, false);
      }, { passive: false });
      function end() {
        if (!g) return;
        var was = g;
        g = null;
        if (!was.on) return;
        stopClick = Date.now();
        if (was.dy > Math.min(140, box.offsetHeight * 0.25) || (was.v > 0.5 && was.dy > 24)) {
          box.style.transition = 'transform .22s ease-in, opacity .22s';
          box.style.transform = 'translateY(100%)';
          back.style.transition = '';
          back.style.opacity = '';
          close();
        } else {
          sheet(0, true);
          later(function () { if (!g) clear(); }, 300);
        }
      }
      dlg.addEventListener('touchend', end);
      dlg.addEventListener('touchcancel', end);
      /* a pull is not a tap: nothing is added when the finger lifts on a row */
      dlg.addEventListener('click', function (e) {
        if (Date.now() - stopClick < 400) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      function clear() {
        box.style.transition = ''; box.style.transform = '';
        back.style.transition = ''; back.style.opacity = '';
      }
      return clear;
    }
 
    /* ---------- events ---------- */
    function bind() {
      dlg.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-close]')) { close(); return; }
        var b = t.closest('button, a');
        if (b && b.hasAttribute('data-how')) {
          e.preventDefault();
          scrollToEl(dlg.querySelector('#' + uid + '-m'), false);
          return;
        }
        if (b && b.hasAttribute('data-show')) { scrollToEl(tbody.querySelector('tr.is-best'), true); return; }
        if (b && b.hasAttribute('data-find')) { scrollToEl(dlg.querySelector('#' + uid + '-f'), false); return; }
        if (b && b.hasAttribute('data-radd')) { tapRow(parseFloat(b.getAttribute('data-radd'))); return; }
        if (b && b.hasAttribute('data-tab')) { S.tab = b.getAttribute('data-tab'); paint(); return; }
        if (b && b.hasAttribute('data-cart')) {
          close(true);
          document.dispatchEvent(new CustomEvent('cart:open'));
          return;
        }
        if (b && b.hasAttribute('data-unit')) {
          S.unit = b.getAttribute('data-unit');
          if (S.foot >= 10) KS.remember({ foot: S.foot, fit: S.fit, socks: S.socks, unit: S.unit });
          paint();
          return;
        }
        if (b && b.hasAttribute('data-fit')) { S.fit = b.getAttribute('data-fit'); S.socks = false; onDraft(); return; }
        if (b && b.hasAttribute('data-pid')) {
          var p = SV && SV.get(b.getAttribute('data-pid'));
          if (!p) { paint(); return; }
          S.pid = p.id; S.foot = p.foot; S.fit = p.fit; S.socks = !!p.socks; S.note = null; S.done = null;
          if (cfg.keep) SV.pick(p.id);
          paint();
          return;
        }
        if (b && b.hasAttribute('data-color')) {
          S.color = b.getAttribute('data-color'); S.note = null; S.done = null;
          paint();
          return;
        }
        var tr = t.closest('tr[data-us]');
        if (tr && tbody.contains(tr)) tapRow(parseFloat(tr.getAttribute('data-us')));
      });
 
      if (input) {
        input.addEventListener('input', function () {
          var raw = input.value.trim();
          S.foot = raw ? KS.toCm(raw, S.unit) : NaN;
          onDraft();
        });
        input.addEventListener('blur', function () { paint(); });
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
      }
 
      /* tap for a millimetre, hold to keep going */
      var holdT = null;
      function stopHold() { if (holdT) { clearTimeout(holdT); holdT = null; } }
      $$('[data-inc]').forEach(function (b) {
        var dir = +b.getAttribute('data-inc');
        b.addEventListener('pointerdown', function (e) {
          if (e.button) return;
          e.preventDefault();
          stopHold();
          bump(dir);
          var n = 0;
          (function loop(delay) {
            holdT = later(function () { bump(dir); n++; loop(n > 12 ? 35 : 75); }, delay);
          })(420);
        });
        ['pointerup', 'pointerleave', 'pointercancel', 'lostpointercapture'].forEach(function (ev) {
          b.addEventListener(ev, stopHold);
        });
        b.addEventListener('click', function (e) { if (e.detail === 0) bump(dir); });
        b.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      });
      window.addEventListener('pointerup', stopHold);
      window.addEventListener('blur', stopHold);
 
      /* ---------- sneaker size converter ----------
         The brand's own chart says which foot each of its sizes is made
         for. That becomes the foot length, and the note says so. */
      if (HAS_CONV) (function () {
        var cb = $('[data-cb]'), cg = $('[data-cg]'), cs = $('[data-cs]'), cn = $('[data-cn]');
        var groups = KS.brandList(), sys = 'us';
        function opts(sel, items, ph) {
          sel.innerHTML = '<option value="">' + esc(ph) + '</option>' + items.map(function (i) {
            return '<option value="' + esc(i.v) + '">' + esc(i.l) + '</option>';
          }).join('');
          sel.disabled = !items.length;
        }
        function sizes(keep) {
          var s = cb.value && cg.value ? KS.brandSizes(cb.value, cg.value) : [];
          opts(cs, s.map(function (x) { return { v: x.label, l: KS.brandSizeLabel(x, sys) }; }), 'Size');
          if (keep) cs.value = keep;
        }
        opts(cb, groups.map(function (g) { return { v: g.brand, l: g.name }; }), 'Brand');
        opts(cg, [], 'Who for');
        opts(cs, [], 'Size');
        pressed('[data-csys]', 'data-csys', sys);
        cb.addEventListener('change', function () {
          cn.innerHTML = '';
          var g = groups.filter(function (x) { return x.brand === cb.value; })[0];
          opts(cg, g ? g.genders.map(function (x) { return { v: x.key, l: x.name }; }) : [], 'Who for');
          opts(cs, [], 'Size');
          if (g && g.genders.length === 1) { cg.value = g.genders[0].key; sizes(null); }
        });
        cg.addEventListener('change', function () { cn.innerHTML = ''; sizes(null); });
        $$('[data-csys]').forEach(function (b) {
          b.addEventListener('click', function () {
            sys = b.getAttribute('data-csys');
            pressed('[data-csys]', 'data-csys', sys);
            if (!cs.disabled) sizes(cs.value);
          });
        });
        cs.addEventListener('change', function () {
          var cm = cb.value && cg.value && cs.value ? KS.brandToCm(cb.value, cg.value, cs.value) : null;
          if (cm === null || isNaN(cm)) { cn.innerHTML = ''; return; }
          var eu = KS.brandEu(cb.value, cg.value, cs.value);
          S.foot = Math.round(cm * 100) / 100;
          cn.innerHTML = fill(tx('brand_note', '[brand] is made for a foot about [length] long, so that is the length used here. It comes from the [name] chart, not your foot, so measure if you can.'), {
            brand: '<b>' + esc(KS.brandName(cb.value) + ' ' + KS.genderName(cb.value, cg.value) + ' US ' + cs.value + (eu ? ' · EU ' + eu : '')) + '</b>',
            length: '<b>' + esc(trim(cm) + ' cm') + '</b>',
            name: esc(KS.brandName(cb.value))
          });
          KS.track('ks_chart_brand', { brand: cb.value, chart: cg.value, brand_size: cs.value, foot_cm: cm });
          onDraft(true);
        });
      })();
 
      /* Escape closes, Tab stays inside the window */
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key !== 'Tab') return;
        var f = $$('button, [href], input, select, [tabindex]:not([tabindex="-1"])').filter(function (el) {
          return !el.disabled && el.offsetParent !== null;
        });
        if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      });
 
      /* saved or deleted in the size helper, another tab or the finder */
      document.addEventListener('ks:sizes', function () { if (S.open) paint(); });
 
      bindPeek();
      resetSheet = bindSwipe();
    }
 
    /* ---------- what opens it ---------- */
    function isThemeBtn(el) {
      return el && el.closest ? el.closest('tool-tip-trigger[data-tool-tip="size-chart"]') : null;
    }
    var themeBtns = scope.querySelectorAll('tool-tip-trigger[data-tool-tip="size-chart"]');
 
    /* Runs before the theme's own handler (capture), so the theme's
       picture window never opens. */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (cfg.themeBtn) {
        var tb = isThemeBtn(e.target);
        if (tb && scope.contains(tb)) {
          e.preventDefault();
          e.stopPropagation();
          open(tb);
          return;
        }
      }
      if (cfg.links) {
        if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest('a[href]');
        if (!a || !scope.contains(a) || (dlg && dlg.contains(a))) return;
        if (!/size\s*chart/i.test(a.textContent || '')) return;
        if (!/\/pages\//.test(a.getAttribute('href') || '')) return;
        e.preventDefault();
        open(a);
      }
    }, true);
 
    if (cfg.themeBtn) {
      /* the theme's button is a plain element; make it reachable by keyboard */
      Array.prototype.forEach.call(themeBtns, function (tb) {
        var el = tb.querySelector('.tool-tip-trigger__title') || tb;
        el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(tb); }
        });
      });
    }
 
    if (cfg.ownBtn && (!themeBtns.length || !cfg.themeBtn) && sizeWrap && sizeWrap.parentNode) {
      var own = document.createElement('button');
      own.type = 'button';
      own.className = 'kssc-open';
      own.innerHTML = '<span>' + esc(tx('title', 'Size chart')) + '</span>' + I.ruler;
      sizeWrap.parentNode.insertBefore(own, sizeWrap);
      own.addEventListener('click', function () { open(own); });
    }
 
    root.__kssc = { open: open, close: close };
  }
 
  window.KSSizeChart = init;
  document.querySelectorAll('[data-kssc]').forEach(init);
  if (!window.__ksscBound) {
    window.__ksscBound = true;
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target && e.target.querySelector ? e.target.querySelector('[data-kssc]') : null;
      if (r) init(r);
    });
  }
})();
